import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Logo from './Logo';
import Buttons from './Buttons';
import s from './LoginElement.css';

class LoginElement extends React.Component {
  render() {
    const { elementType, hostname } = this.props;
    switch (elementType) {
      case 'LOGO':
        return <Logo hostname={hostname} />;
      case 'BUTTONS_LOGIN':
      case 'BUTTONS_REGISTER':
      case 'BUTTONS_FORGOT':
      case 'BUTTONS_CLEAR':
        return <Buttons elementType={elementType} hostname={hostname} />;
      default:
        return null;
    }
  }
}

LoginElement.propTypes = {
  elementType: PropTypes.string.isRequired,
  hostname: PropTypes.string,
};

LoginElement.defaultProps = {
  hostname: '',
};

export default withStyles(s)(LoginElement);


// WEBPACK FOOTER //
// ./src/components/LoginElements/LoginElement.js